import React from 'react';
import { Link } from 'react-router-dom';  
import Logo from '../assets/icons/Logo'; 
import SmartPart from '../assets/images/SmartPart.png';

const Navbar = () => {
  return (
    <div style={styles.navBarSection}>
    <header style={styles.navbar}>
      <div style={styles.logoContainer}> 
<Logo/>
        <img src={SmartPart} alt="SmartPart" style={styles.logoText} />
      </div>
      <nav style={styles.nav}>
        <a href="#home" style={styles.link}>Kako funkcionise?</a>
        <a href="#about" style={styles.link}>Postavi zahtev</a>
        <a href="#parts" style={styles.link}>O nama</a>
        <a href="#contact" style={styles.link}>Kontakt</a>

        <Link to="/signin" style={styles.ctaButton1}>Login za kupce</Link>
        <Link to="/signin-seller" style={styles.ctaButton2}>Login za partnere</Link>
      </nav>
    </header>
    </div>
  );
};

export default Navbar;

const styles = {
  navBarSection:{
    backgroundColor: 'rgb(23, 23, 24)',
    paddingTop: '20px'

  },
  navbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 40px',
    backgroundColor: '#333333',
    borderBottom: '1px solid #2a2a2a',
    borderRadius: '24px',
    
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
 
  logoText: {
    height: 30,
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    gap: 24,
  },
  link: {
    fontSize: '32px',
    fontWeight: 700,
    color: '#d3e205',
    lineHeight: '36px',
  },

  ctaButton1: {
    marginLeft: 16,
    width: '186px',  
    height: '65px', 
    backgroundColor: 'rgba(211, 226, 5, 1)',
    color: '#0f0f0f',
    borderRadius: '12px',
    fontWeight: 600,
    fontSize: '24px',  
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  ctaButton2: {
    marginLeft: 16,
    width: '213px', 
    height: '65px',  
    backgroundColor: 'rgb(148, 191, 254)',
    color: '#0f0f0f',
    borderRadius: '12px',
    fontWeight: 600,
    fontSize: '24px', 
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};
